export const defaultEntityProfileWidgets = [
	{
		enabled: true,
		id: "alerts",
		index: 0
	},
	{
		enabled: true,
		id: "activities",
		index: 1
	},
	{
		enabled: true,
		id: "files",
		index: 2
	},
	{
		enabled: true,
		id: "details",
		index: 3
	},
	{
		enabled: true,
		id: "rules",
		index: 4
	},
	{
		enabled: true,
		id: "cameras",
		index: 5
	},
	{
		enabled: false,
		id: "marineTrafficParticulars",
		index: 6
	},
	{
		enabled: true,
		id: "drone-association",
		index: 7
	},
	{
		enabled: true,
		id: "device-manager",
		index: 8
	}
];
